// © 2025 nSide, Inc. All Rights Reserved.
// This software and its source code are the confidential and proprietary
// information of nSide, Inc. (“Confidential Information”). You may not
// use, reproduce, disclose, distribute, modify, or create derivative works
// of this code except in accordance with a written license agreement or
// other written authorization from nSide, Inc.

// Unauthorized use is strictly prohibited and may result in civil and
// criminal penalties.



import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authInterceptor } from './app/interceptors/auth.interceptor';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    provideToastr()
  ]
}).catch(err => console.error(err));
